import classNames from 'classnames'
import ProjectPathwayBanner from 'components/shared/ProjectPathwayBanner/ProjectPathwayBanner'
import { getPathwayDetails } from 'helpers/Project'
import { themeClassName } from 'helpers/Project'
import { userManager } from 'helpers/authentication'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import './Editor.scss'
import questionStyles from '../Project/Project/Step/KnowledgeQuiz/Question/Question.css?raw'
import editorKnowledgeQuizStyles from './EditorKnowledgeQuiz.css?raw'

const Editor = ({ project, quiz, currentStepPosition, t, locale }) => {
  const isAuthenticated = useSelector((state) => {
    if (!state?.authentication) {
      return false
    }
    return state.authentication.user !== null
  })

  useEffect(() => {
    if (!isAuthenticated) {
      userManager.removeUser()
    }
  }, [isAuthenticated])

  const { slug: pathwaySlug = null, title: pathwayTitle = null } =
    getPathwayDetails(project?.included)
  const classes = {}
  classes[themeClassName(project.theme)] = project?.theme
  const instructions = { project, currentStepPosition, quiz }
  const authKey = isAuthenticated
    ? `oidc.user:${import.meta.env.VITE_AUTHENTICATION_URL}:${import.meta.env.VITE_AUTHENTICATION_CLIENT_ID}`
    : null

  return (
    <div className={classNames('c-editor', classes)}>
      {pathwaySlug && pathwayTitle && (
        <ProjectPathwayBanner
          slug={pathwaySlug}
          pathwayTitle={pathwayTitle}
          locale={locale}
          t={t}
        />
      )}
      <editor-wc
        class="c-editor__wc"
        auth_key={authKey}
        identifier={project.editorStarterProject}
        data-editor-target="editor"
        instructions={JSON.stringify(instructions)}
        with_projectbar="true"
        with_sidebar="true"
        sidebar_options={JSON.stringify([
          'instructions',
          'file',
          'images',
          'download',
          'settings',
          'info',
        ])}
        host_styles={JSON.stringify([
          questionStyles,
          editorKnowledgeQuizStyles,
        ])}
        theme="light"
      />
    </div>
  )
}

Editor.propTypes = {
  locale: PropTypes.string.isRequired,
  project: PropTypes.object,
  currentStepPosition: PropTypes.number,
  t: PropTypes.func.isRequired,
  quiz: PropTypes.object,
}

export { Editor }
export default withTranslation('translations')(Editor)
